export default __webpack_public_path__ + "static/media/org.9fde8d1c.jpg";